import { useLanguageSwitcher } from 'hooks/useLanguageSwitcher';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, MenuItem, Select, Stack, styled, Text, Tooltip } from 'shell/components';
import { LanguageList } from 'utils/constants';

const Language = () => {
    const { currentLanguage, switchLanguage } = useLanguageSwitcher();
    const { t } = useTranslation();
    const [language, setLanguage] = useState(currentLanguage);

    const handleSave = () => {
        switchLanguage(language);
    };

    return (
        <CustomStack spacing={4}>
            <Stack spacing={7}>
                <Text component={'h1'} variant={'h6'}>
                    {t('account-settings.general-settings.title', 'General Settings')}
                </Text>
                <CustomSelect
                    fullWidth
                    label={
                        <Stack alignItems={'center'} component={'span'} direction={'row'} spacing={2}>
                            <Text>
                                {t(
                                    'account-settings.general-settings.personal-language-preference',
                                    'Personal Language Preference'
                                )}
                            </Text>
                            <CustomTooltip
                                content={t(
                                    'account-settings.general-settings.personal-language-preference-description',
                                    'This change affects only your view in this course and does not impact students. Outside the course, your default language will be used.'
                                )}
                                type={'info'}
                            />
                        </Stack>
                    }
                    labelId={'language-select-label'}
                    value={language}
                    onChange={(event) => setLanguage(event.target.value)}
                >
                    {LanguageList.map((lang) => (
                        <MenuItem key={lang.value} value={lang.value}>
                            {lang.label}
                        </MenuItem>
                    ))}
                </CustomSelect>
            </Stack>
            <SaveButton variant={'primary'} onClick={handleSave}>
                {t('controls.save', 'Save')}
            </SaveButton>
        </CustomStack>
    );
};

const SaveButton = styled(Button)(({ theme }) => {
    return {
        marginLeft: 'auto',
        paddingInline: theme.spacing(6),
        minWidth: '65px',
    };
});

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        padding: theme.spacing(5, 4),
        height: 'calc(100vh - 64px - 20px)',
        maxWidth: '400px',
    };
});

const CustomSelect = styled(Select)(({ theme }) => {
    return {
        gap: theme.spacing(1.5),
    };
});

const CustomTooltip = styled(Tooltip)(({ theme }) => {
    return {
        '&:focus-visible': {
            outline: `${theme.palette.ensightful.secondary[100]} solid 3px`,
            outlineOffset: '-5px',
        },
        '&.MuiSvgIcon-root': {
            width: '1rem',
            height: '1rem',
            padding: '0.1875rem',
        },
    };
});

export default Language;
